<template>
    <ValidationProvider
        :vid="vid"
        :rules="rules"
        :name="label"
        v-slot="{ errors }"
        tag="div"
        class="form-group"
        :class="{ 'form-group-compact': compact, 'mb-0': noBottomMargin }"
    >
        <label v-if="label && !hideLabel">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <div class="input-group">
            <div v-if="$slots['input-group-prepend']" class="input-group-prepend">
                <slot name="input-group-prepend"></slot>
            </div>
            <b-form-input
                :placeholder="placeholder ? placeholder : label"
                :type="type"
                :value="value"
                @input="handleInput"
                :disabled="disabled"
                :state="(errors.length > 0 ? false : null)"
            />
            <div v-if="$slots['input-group-append']" class="input-group-append">
                <slot name="input-group-append"></slot>
            </div>
        </div>
        <span class="validation-invalid-label">{{ getInvalidFeedback(errors) }}</span>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
    name: 'InputWithValidation',
    props: {
        vid: null,
        rules: {
            type: [String, Object, Array],
            default: '',
        },
        value: null,
        label: String,
        hideLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        type: {
            type: String,
            default: 'text',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        noBottomMargin: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ValidationProvider,
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        getInvalidFeedback(errors, key = null) {
            if (key) {
                if (Array.isArray(errors[key]) && errors[key].length) {
                    return errors[key].join(', ');
                }
            }

            if (Array.isArray(errors) && errors.length) {
                return errors.join(', ');
            }

            return null;
        },
    },
    computed: {
        required() {
            if (this.rules instanceof Object) {
                return this.rules.required ?? false;
            }
            return this.rules?.includes('required') ?? false;
        },
    },
};
</script>

<style>
.form-group.form-group-compact {
    margin-bottom: 0.625rem;
}
.form-group.form-group-compact .col-form-label, .form-group.form-group-compact label {
    margin-bottom: 0.25rem;
}
</style>
